module.exports = __webpack_public_path__ + "img/nocandidate.444b5d4e.svg";